import React from "react";
import CashierSalesReport from "../pages/Reports/CashSalesReport/CashierSalesReport";
import { Route, Routes } from "react-router-dom";
import PrintCashierSalesReport from "../pages/Reports/CashSalesReport/PrintCashierSalesReport";
import BranchSalesReport from "../pages/Reports/CashSalesReport/BranchSalesReport";
import SessionSalesReport from "../pages/Reports/CashSalesReport/SessionSalesReport";
import DetailedSessionSalesReport from "../pages/Reports/CashSalesReport/DetailedSessionSalesReport";
import BranchCustomerCreditReport from "../pages/Reports/CreditSalesReport/BranchCustomerCreditReport";
import StaffCustomerCreditReport from "../pages/Reports/CreditSalesReport/StaffCustomerCredit";
import CreditRepaymentReport from "../pages/Reports/CreditSalesReport/CreditRepaymentReport";
import PrintCreditSales from "../pages/Reports/CreditSalesReport/PrintCreditSales";
import InternalUsageReport from "../pages/Reports/CreditSalesReport/InternalUsageReport";
import PrintInternalUsageReport from "../pages/Reports/CreditSalesReport/PrintInternalUsageReport";
import InterbranchReport from "../pages/Reports/TransactionReport/InterbranchReport";
import PrintInterbranchReport from "../pages/Reports/TransactionReport/PrintInterbranchReport";
import RequestReport from "../pages/Reports/RequisitionReport/RequestReport";
import WarehouseSupplyReport from "../pages/Reports/RequisitionReport/WarehouseSupplyReport";
import PrintRequisitionReport from "../pages/Reports/RequisitionReport/PrintRequisitionReport";
import BranchReceiptReport from "../pages/Reports/RequisitionReport/BranchReceiptReport";
import RetailItemHistory from "../pages/Reports/Inventory/RetailItemHistory";
import PrintItemHistory from "../pages/Reports/Inventory/PrintItemHistory";
import SupplierPayment from "../pages/Reports/PurchasesReport/SupplierPayment";
import PrintSupplierPayment from "../pages/Reports/PurchasesReport/PrintSupplierPayment";
import SupplierInvoiceReport from "../pages/Reports/PurchasesReport/SupplierInvoiceReport";
import PrintSupplierInvoiceReport from "../pages/Reports/PurchasesReport/PrintSupplierInvoiceReport";
import SupplierInvoiceReportDetails from "../pages/Reports/PurchasesReport/SupplierInvoiceReportDetails";
import StockReport from "../pages/Reports/Inventory/StockReport";
import PrintStockReport from "../pages/Reports/Inventory/PrintStockReport";
import ExpenseReport from "../pages/Reports/TransactionReport/ExpenseReport";
import PrintExpenseReport from "../pages/Reports/TransactionReport/PrintExpenseReport";
import PrintSessionSalesDetailReport from "../pages/Reports/CashSalesReport/PrintSessionSalesDetailReport";
import PrintSessionSalesReport from "../pages/Reports/CashSalesReport/PrintSessionSalesReport";
import WarehouseItemHistory from "../pages/Reports/Inventory/WarehouseItemHistory";
import PrintWarehouseItemHistory from "../pages/Reports/Inventory/PrintWarehouseItemHistory";
import IncomeStatement from "../pages/Reports/TransactionReport/IncomeStatement";
import ReconciliationReport from "../pages/Reports/Inventory/ReconciliationReport";
import PrintStoresItemHistory from "../pages/Reports/Inventory/PrintStoresItemHistory";
import StoresItemHistory from "../pages/Reports/Inventory/StoresItemHistory";
import DrugActivityReport from "../pages/Reports/Inventory/DrugActivityReport";

const ReportRoutes = () => {
  return (
    <Routes>
      <Route path="/cash/sales" element={<CashierSalesReport />} />
      <Route path="/cash/sales/print" element={<PrintCashierSalesReport />} />
      <Route path="/cash/branch" element={<BranchSalesReport />} />
      <Route path="/cash/session" element={<SessionSalesReport />} />
      <Route path="/cash/session/print" element={<PrintSessionSalesReport />} />
      <Route
        path="/cash/session/details"
        element={<DetailedSessionSalesReport />}
      />
      <Route
        path="/cash/session/details/print"
        element={<PrintSessionSalesDetailReport />}
      />

      {/* CREDIT */}
      <Route
        path="/credit/outstanding"
        element={<BranchCustomerCreditReport />}
      />
      <Route path="/credit/cashier" element={<StaffCustomerCreditReport />} />
      <Route path="/credit/repayment" element={<CreditRepaymentReport />} />
      <Route path="/credit/outstanding/print" element={<PrintCreditSales />} />
      <Route path="/credit/internal" element={<InternalUsageReport />} />
      <Route
        path="/credit/internal/print"
        element={<PrintInternalUsageReport />}
      />

      {/* TRANSACTION */}
      <Route path="/transaction/interbranch" element={<InterbranchReport />} />
      <Route
        path="/transaction/interbranch/print"
        element={<PrintInterbranchReport />}
      />
      <Route path="/transaction/expense" element={<ExpenseReport />} />
      <Route
        path="/transaction/expense/print"
        element={<PrintExpenseReport />}
      />
      <Route
        path="/transaction/income-statement"
        element={<IncomeStatement />}
      />

      {/* INVENTORY */}
      <Route path="/inventory/request" element={<RequestReport />} />
      <Route path="/inventory/supply" element={<WarehouseSupplyReport />} />
      <Route path="/inventory/receipt" element={<BranchReceiptReport />} />
      <Route
        path="/inventory/requisition/print"
        element={<PrintRequisitionReport />}
      />
      <Route path="/inventory/history/retail" element={<RetailItemHistory />} />
      <Route
        path="/inventory/history/retail/print"
        element={<PrintItemHistory />}
      />
      <Route
        path="/inventory/history/warehouse"
        element={<WarehouseItemHistory />}
      />
      <Route
        path="/inventory/history/warehouse/print"
        element={<PrintWarehouseItemHistory />}
      />
      <Route path="/inventory/history/stores" element={<StoresItemHistory />} />
      <Route
        path="/inventory/history/stores/print"
        element={<PrintStoresItemHistory />}
      />
      <Route path="/inventory/stock" element={<StockReport />} />
      <Route path="/inventory/stock/print" element={<PrintStockReport />} />
      <Route
        path="/inventory/reconciliation"
        element={<ReconciliationReport />}
      />
      <Route path="/inventory/activity" element={<DrugActivityReport />} />

      {/* PURCHASES */}
      <Route path="/purchases/supplier/payment" element={<SupplierPayment />} />
      <Route
        path="/purchases/supplier/payment/print"
        element={<PrintSupplierPayment />}
      />
      <Route path="/purchases/invoice" element={<SupplierInvoiceReport />} />
      <Route
        path="/purchases/invoice/print"
        element={<PrintSupplierInvoiceReport />}
      />
      <Route
        path="/purchases/invoice/details/:invoice_id"
        element={<SupplierInvoiceReportDetails />}
      />
    </Routes>
  );
};

export default ReportRoutes;
